import domainDictionary from './domainDictionary';

export default {
    linkInsert(link) {
        let host = getHost(link);
        gtag('event', 'link-insert', {
            'send_to': 'main',
            'event_category': 'main-page',
            'event_label': host
        });
    },
    linkSubmit(link) {
        let host = getHost(link);
        gtag('event', 'link-submit', {
            'send_to': 'main',
            'event_category': 'main-page',
            'event_label': host
        });
    },
    keywordSubmit(keyword) {
        gtag('event', 'keyword-submit', {
            'send_to': 'main',
            'event_category': 'main-page',
            'event_label': true
        });
    },
    keywordInsert(keyword) {
        gtag('event', 'keyword-insert', {
            'send_to': 'main',
            'event_category': 'main-page',
            'event_label': true
        });
    },
    searchDownload(url) {
        gtag('event', 'search-download', {
            'send_to': 'main',
            'event_category': 'vidacha',
            'event_label': true
        });
    },
    downloadClick(link, format) {
        let host = getHost(link);
        gtag('event', 'download-click', {
            'send_to': 'main',
            'event_category': 'vidacha',
            'event_label': host,
            'dimension1': format
        });
    },
    showResults(link) {
        let host = getHost(link);
        gtag('event', 'show', {
            'send_to': 'main',
            'event_category': 'vidacha',
            'event_label': host
        });
    },
    showError(e) {
        if (!e) {
            gtag('event', 'not_found', {
                'send_to': 'main',
                'event_category': 'vidacha',
                'event_label': 'fatal'
            });
            return;
        }
        if (e.timeout) {
            gtag('event', 'not_found', {
                'send_to': 'main',
                'event_category': 'vidacha',
                'event_label': 'timeout_exeeded'
            });
            return;
        }
        if (e.supported_resource === null) {
            gtag('event', 'not_found', {
                'send_to': 'main',
                'event_category': 'vidacha',
                'event_label': 'not_supported'
            });
            return;
        }
        if (e.success === false || [100, 101, 102, 103].indexOf(e.code) > -1) {
            gtag('event', 'not_found', {
                'send_to': 'main',
                'event_category': 'vidacha',
                'event_label': 'link_not_found'
            });
            return;
        }
        if (e.status >= 400 && e.status !== 401) {
            gtag('event', 'not_found', {
                'send_to': 'main',
                'event_category': 'vidacha',
                'event_label': 'link_not_found'
            });
            return;
        }
        if (e.status === 401) {
            gtag('event', 'response-error', {
                'send_to': 'main',
                'event_category': 'request-signing',
                'event_label': e.data.error_code || e.data.error || ''
            });
            return
        }
        if (e.blacklist) {
            let serverName = e.srv || '';
            let hosting = e.hosting || '?';
            if (e.hosting_id && e.hosting_id == 101) {
                hosting = 101;
            }
            gtag('event', 'blacklist', {
                'send_to': 'main',
                'event_category': 'failure',
                'event_label': 'blacklist',
                'dimension1': serverName
            });
        }
    },
}

export function getHost(link) {
    let aTmp = document.createElement('a');
    aTmp.href = link;
    return domainDictionary(aTmp.hostname);
}
